import { API_BASE, buildURL, requestJSON } from "./apiClient";

export async function listRegions() {
  const url = buildURL(API_BASE, "/api/regions/sido");
  return requestJSON(url);
}

export async function listDistricts({ sidoCd, sidoNm } = {}) {
  const url = buildURL(API_BASE, "/api/regions/sigungu", { sidoCd, sidoNm });
  return requestJSON(url);
}
